//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import { ListAccounts } from '@/views/accounts'

//
export default {
  path: 'accounts',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'accounts-list',
      component: ListAccounts,
    },
  ],
  meta: {
    group: 'Contabilidad',
    title: 'Cuentas',
  },
}
